import { useUiStore, useStorageStore, useLoginStore } from "@/store";
import helper from "@/shared/utills/helper";
import { dateTime } from "@/shared/utills/date";

export default function registerUiActions(app) {
  const { globalProperties } = app.config;

  const uiStore = useUiStore();
  const storageStore = useStorageStore();
  const loginStore = useLoginStore();

  Object.assign(globalProperties, {
    $startLoading: uiStore.startLoading,
    $stopLoading: uiStore.stopLoading,
    $startGlobalLoading: uiStore.startGlobalLoading,
    $stopGlobalLoading: uiStore.stopGlobalLoading,
    $showNotification: uiStore.showNotification,
    $showDialog: uiStore.openMidDialog,
    $closeDialog: uiStore.closeMidDialog,
    $showConfirmPopup: uiStore.showConfirm,

    // Storage
    $localStorage: storageStore,

    // Helpers
    $helper: helper,
    $dateTime: dateTime,

    // Validation
    $getFieldError: (field) => field?.$invalid && field?.$dirty,
    $getFieldMessages: (field) => field?.$errors?.map(({ $message }) => $message) || [],
  });

  // Auth - always returns latest login details
  Object.defineProperty(globalProperties, "$auth", {
    configurable: true,
    get: () => loginStore.loginDetails,
  });
}
